import { Components, Theme } from "@mui/material/styles";

export const MuiRadio = () =>
  ({
    MuiRadio: {
      defaultProps: {
        color: "primary",
      },
    },
  }) satisfies Components<Theme>;
